export default __webpack_public_path__ + "static/media/Logo_footer.728efd51.svg";